import React, { useState } from "react";
import styles from "../../../assets/styles/AuthComponents.module.scss";
import { useNavigate } from "react-router-dom";
import AuthService from "../../../api/services/auth.service";
import Input from "../../../components/common/input/Input";
import { useAuth } from "../../../context/AuthContext";
import AuthHeader from "../../../components/common/header/auth-header/AuthHeader";
import TitleUpdater from "../../../components/common/title/TitleUpdater";
import { useTranslation } from "react-i18next";

const ForgetPassword = () => {
  const { t } = useTranslation("translation");
  const { setEmail } = useAuth();
  const [emailValue, setEmailValue] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!emailValue) {
      setErrorMessage(t("required.email") || "");
      return;
    }
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("email", emailValue);
      const res = await AuthService.forgetPassword(formData);
      if (res.data) {
        navigate("/auth/confrim-forget-password");
        setEmail(emailValue);
      }
    } catch (error: any) {
      setLoading(false);
      const message =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        t("error_message");
      setErrorMessage(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <TitleUpdater title={t("login.forget_password")} />
      <form className={styles.form} onSubmit={handleSubmit}>
        <AuthHeader
          onBackClick={() => navigate("/auth/login")}
          title={t("login.forget_password")}
        />
        <Input
          label={t("labels.email") || ""}
          name="email"
          placeholder={t("placeholders.email") || ""}
          type="email"
          id="email"
          value={emailValue}
          onChange={(e) => {
            setEmailValue(e.target.value);
            setErrorMessage("");
          }}
          error={errorMessage}
        />
        <button type="submit" className={styles.button} disabled={loading}>
          {loading ? t("buttons.loading") : t("submit")}
        </button>
      </form>
    </div>
  );
};

export default ForgetPassword;
